module.exports = __webpack_public_path__ + "img/area-part3-521.2bdeb52a.png";